import { Button, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './EmptyText.module.scss';

const { Text } = Typography;

const EmptyText = ({
  tableHeight,
  setSearchQuery,
}: {
  tableHeight: number;
  setSearchQuery: (search: string) => void;
}): React.ReactElement => {
  const { t } = useTranslation('Calendar');

  return (
    <Space direction="vertical" className={styles.emptyTable} style={{ height: tableHeight }}>
      <Text type="secondary" className={styles.emptyText}>
        {t('calendarsTable.body.empty.text')}
      </Text>
      <Button type="text" onClick={() => setSearchQuery('')}>
        <Text className={styles.resetButtonText}>{t('calendarsTable.body.empty.resetButton.text')}</Text>
      </Button>
    </Space>
  );
};

export { EmptyText };
